module.exports = __webpack_public_path__ + "resources/icon_50_close_small.588785df419481dc.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/strategy-lib-dialog/img/icon_50_close_small.png
// module id = 603
// module chunks = 0 1 2 3